export default __webpack_public_path__ + "static/media/Refresh.55bd51c4.svg";